import Loader from '@ulta/core/components/Loader/Loader';

export default Loader;
